import { z } from 'zod';

import { createApiClient } from '../../api';
import type { LanguageChoice } from '../../i18n/languages';
import { sidebarSchema } from '../sidebar/sidebarItems';
import type { SidebarItem } from '../sidebar/sidebarItems';

import { ACCESS_ENDPOINTS } from './endpoints';
import { errorFrom } from './http';
import { AccessContractError } from './schemas';

const { request } = createApiClient({ toError: errorFrom });

const SIDEBAR_TIMEOUT_MS = 8_000;

const resolvedMenuSchema = z.object({ menu: sidebarSchema });

/** The signed-in person's sidebar, its labels in the language they picked. */
export const fetchSidebar = async (language: LanguageChoice, signal?: AbortSignal): Promise<readonly SidebarItem[]> => {
  const raw = await request('get', ACCESS_ENDPOINTS.SIDEBAR, { params: { resolve: true, lang: language }, signal, timeoutMs: SIDEBAR_TIMEOUT_MS });
  const parsed = resolvedMenuSchema.safeParse(raw);
  if (!parsed.success) throw new AccessContractError('Invalid /v2/permissions/menu payload', parsed.error.issues);
  return parsed.data.menu;
};
